import { AdditionalGoal, Diagnosis, Goal, MedicalDiagnosis, VisitFrequency } from 'domains/care-plans';
import { CareTeam } from 'domains/care-teams';
import { FullClient } from 'domains/client';

/** note(juan): should be updated anytime the ScreenerResults type changes, in order to prevent loading old data with a different contract */
const CARE_PLAN_STORAGE_VERSION = 'v1.0';

export type CarePlanSummary = {
  visitFrequency: VisitFrequency;
  medicalDiagnoses: MedicalDiagnosis[];
  diagnoses: Diagnosis[];
  clientInfo: FullClient;
  therapistInfo: CareTeam;
  goals: Goal[];
  additionalGoals: AdditionalGoal[];
};

export type CarePlanStorage = {
  version: typeof CARE_PLAN_STORAGE_VERSION;
  data: CarePlanSummary;
};

const CARE_PLAN_PDF_LS_KEY = 'screener-results';

export const getCarePlanPDFStoragePair = ({
  clientInfo,
  diagnoses,
  medicalDiagnoses,
  therapistInfo,
  visitFrequency,
  goals,
  additionalGoals,
}: CarePlanSummary): [string, string] => {
  const value = JSON.stringify({
    version: 'v1.0',
    data: { visitFrequency, medicalDiagnoses, diagnoses, clientInfo, therapistInfo, goals, additionalGoals },
  } as CarePlanStorage);

  return [CARE_PLAN_PDF_LS_KEY, value];
};

export const saveCarePlanToStorage = (data: CarePlanSummary) => {
  localStorage.setItem(...getCarePlanPDFStoragePair(data));
};

export const loadCarePlanFromStorage = (): CarePlanSummary | null => {
  const storageString = localStorage.getItem(CARE_PLAN_PDF_LS_KEY);

  if (!storageString) {
    return null;
  }
  const storage: CarePlanStorage = JSON.parse(storageString);

  if (storage.version !== CARE_PLAN_STORAGE_VERSION) {
    return null;
  }

  return storage.data;
};
